import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TJotformStore,
	TJotform,
	TJotformListResponsePayload,
	TJotformListResponse,
	TJotformWarning,
	TCreateEmerchantResponsePayload,
} from './types';

// ==========================================:
const getJotformState = (state: TStoreState): TJotformStore => state.jotform;
export const getJotform = createSelector([getJotformState], (jotform: TJotformStore) => jotform);

// ====================================================:
export const getJotformsLoad = createSelector(
	[getJotform],
	(jotform: TJotformStore): boolean => jotform.jotformsIsLoading,
);

// ====================================================:
export const getJotforms = createSelector(
	[getJotform],
	(jotform: TJotformStore): TJotformListResponse | null => jotform.jotforms,
);

// ====================================================:

export const getJotformLoad = createSelector(
	[getJotform],
	(jotform: TJotformStore): boolean => jotform.jotformIsLoading,
);

// ====================================================:

export const getJotformItem = createSelector(
	[getJotform],
	(jotform: TJotformStore): TJotform | null => jotform.jotform,
);

// ====================================================:

export const getCreateEmerchantLoad = createSelector(
	[getJotform],
	(jotform: TJotformStore): boolean => jotform.createEmerchantIsLoading,
);

// ====================================================:

export const getCreateEmerchantWarning = createSelector(
	[getJotform],
	(jotform: TJotformStore): TJotformWarning | null => jotform.createEmerchantWarning,
);

// ====================================================:

export const getCreateEmerchantSuccess = createSelector(
	[getJotform],
	(jotform: TJotformStore): TCreateEmerchantResponsePayload => jotform.createEmerchantSuccess,
);
